import { getB2BUrlByEnv } from './getB2BUrlByEnv';
import { OAUTH_CODE_STATE_FIELDS } from './oauth';

export const JIVO_SERVICE_NAME = 'Jivo';

/** Путь для обработки OAuth-колбека Jivo */
export const JIVO_OAUTH_CALLBACK_PATH = '/jivo-oauth-callback';

/** Redirect URI для OAuth Jivo
 * @kind helper
 */
export const getJivoRedirectStaticUri = () => getB2BUrlByEnv(JIVO_OAUTH_CALLBACK_PATH);

/** Ключ cookie для передачи authorization code из popup в родительское окно */
export const JIVO_OAUTH_STORAGE_KEY = 'jivo-oauth-params';

export const JIVO_OAUTH_COOKIE_FIELDS = OAUTH_CODE_STATE_FIELDS;
